const transitions = {
  blurLayer: 0.4,
  calendarSlide: 0.4,
  pageContainerIn: 0.5,
  pageContainerOut: 0.2,
  focusSessionZenLogo: 0.5,
}
export default transitions
